import { Label as LabelIcon } from "@mui/icons-material";
import { Chip } from "@mui/material";
import type { FC } from "react";
import { SelectWithColors } from "../../components/entityCard/SelectWithColors";
import { OrderStatus } from "../../data/BaseEntity";
import type { UserRole } from "../../auth/auth";
import { enumKeys } from "../../misc/utils";
import { StatusColors } from "./StatusColors";
import { orderStatusToName } from "./orderStatusToName";

interface Props {
  readonly value: OrderStatus;
  readonly role: UserRole;
  readonly onChange: (value: OrderStatus) => void | Promise<void>;
}

const orderStatusKeys = enumKeys(OrderStatus);
const orderSelectValues = orderStatusKeys.map((key) => ({
  id: key,
  label: orderStatusToName(OrderStatus[key]),
}));

export const OrderStatusSelect: FC<Props> = ({ value, role, onChange }) => {
  const isCustomer = role === "CUSTOMER";
  return isCustomer ? (
    <Chip icon={<LabelIcon style={{ color: StatusColors[value] }} />} label={orderStatusToName(OrderStatus[value])} />
  ) : (
    <SelectWithColors<(typeof orderStatusKeys)[number]>
      values={orderSelectValues}
      value={value}
      colors={StatusColors}
      onChange={(v) => onChange(OrderStatus[v])}
    />
  );
};
